import React from "react";
import styled from "@emotion/styled";
import {
  fontFamily,
  fontSize,
  spacing,
  borderRadius,
  border as borderToken,
  surface,
  text,
} from "@atlas-int/tokens";

interface CodeBlockProps {
  code: string;
  language?: string;
}

const Pre = styled.pre`
  background-color: ${surface.muted};
  border: 1px solid ${borderToken.default};
  border-radius: ${borderRadius.base};
  padding: ${spacing[8]};
  overflow-x: auto;
  margin: ${spacing[4]} 0 0 0;
`;

const Code = styled.code`
  font-family: ${fontFamily.mono};
  font-size: ${fontSize.sm};
  color: ${text.primary};
  line-height: 1.6;
`;

const CodeBlock: React.FC<CodeBlockProps> = ({ code }) => {
  return (
    <Pre>
      <Code>{code}</Code>
    </Pre>
  );
};

export default CodeBlock;
